const mime = require('mime');

export const IconsWithTypes = {
  [mime.getType('.doc')]: 'DocIcon',
  [mime.getType('.dot')]: 'DocIcon',
  [mime.getType('.docx')]: 'DocIcon',
  [mime.getType('.dotx')]: 'DocIcon',
  [mime.getType('.docm')]: 'DocIcon',
  [mime.getType('.dotm')]: 'DocIcon',
  [mime.getType('.xls')]: 'XlsIcon',
  [mime.getType('.xlsx')]: 'XlsIcon',
  [mime.getType('.xltx')]: 'XlsIcon',
  [mime.getType('.xlsm')]: 'XlsIcon',
  [mime.getType('.xltm')]: 'XlsIcon',
  [mime.getType('.xlam')]: 'XlsIcon',
  [mime.getType('.xlsb')]: 'XlsIcon',
  [mime.getType('.ppt')]: 'PptIcon',
  [mime.getType('.pptx')]: 'PptIcon',
  [mime.getType('.potx')]: 'PptIcon',
  [mime.getType('.ppsx')]: 'PptIcon',
  [mime.getType('.ppam')]: 'PptIcon',
  [mime.getType('.pptm')]: 'PptIcon',
  [mime.getType('.potm')]: 'PptIcon',
  [mime.getType('.ppsm')]: 'PptIcon',
  [mime.getType('.csv')]: 'CsvIcon',
  [mime.getType('.html')]: 'LinkIcon',
  [mime.getType('.odp')]: 'OdpIcon',
  [mime.getType('.ods')]: 'OdsIcon',
  [mime.getType('.odt')]: 'OdtIcon',
  [mime.getType('.pdf')]: 'PdfIcon',
  [mime.getType('.rtf')]: 'RtfIcon',
  [mime.getType('.txt')]: 'TxtIcon',
};
